/* eslint-disable jsx-a11y/aria-proptypes */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Button, Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import { useDispatch, useSelector } from "react-redux";
import { setSelected, setApproval, createApproval } from "./fssSlice";
import { useHistory } from "react-router-dom";
import {
  formatDate,
  sizePerPageList,
  showDialog,
  StatusFormatter,
  formatCurrency,
  attachFormatter,
} from "../../utility";
import SVG from "react-inlinesvg";
import { selectUser } from "../../modules/Auth/_redux/authRedux";

export const FssTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector(selectUser);

  const [onSelectAll, setOnSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [tableData, setTableData] = useState(data);

  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
      };
    });
    setTableData(initData);
  }, [data, sizePerPage, page]);

  const editAllowed = ["ADMIN", "SALES_SERVICE", "ADMINISTRATOR"];

  const role = user.roles.map((e) => {
    return e.roleName;
  });

  const checkRoles = (userRoles, allowedRoles) => {
    return userRoles.some((e) => allowedRoles.includes(e));
  };
  const cekRoles = checkRoles(role, editAllowed);

  const showDetail = (column) => {
    dispatch(setSelected(column));
    history.push("/fss-asm-bm/detail-data");
  };

  const linkFormatter = (cell, column) => {
    return (
      <a className={`cursor-pointer`} onClick={() => showDetail(column)}>
        <strong style={{ color: "blue" }}>{cell} </strong>
      </a>
    );
  };

  const dateFormatter = (cell) => {
    return <span>{formatDate(cell)}</span>;
  };

  const actionFormatter = (cell, column) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
        >
          <div
            className="btn btn-icon btn-light btn-hover-danger btn-sm"
            onClick={() => showDetail(column)}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
              />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    // {
    //   text: "Action",
    //   dataField: "action",
    //   formatter: actionFormatter,
    //   hidden: !cekRoles,
    // },
    {
      text: "APL Return Number ",
      dataField: "retNumber",
      formatter: linkFormatter,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Invoice Ref Num",
      dataField: "invoiceNo",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Reason",
      dataField: "reasonName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Cust Name",
      dataField: "customerName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Created By",
      dataField: "userName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Doc Date",
      dataField: "docDate",
      formatter: dateFormatter,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Material",
      dataField: "materialCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Material Desc",
      dataField: "materialName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Rayon Type",
      dataField: "rayonType",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Batch",
      dataField: "batch",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Uom",
      dataField: "uom",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Return Uom",
      dataField: "returnUom",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Nra",
      dataField: "nra",
      sort: true,
      formatter: StatusFormatter,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Qty",
      dataField: "qty",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Net Sales",
      dataField: "netPrice",
      sort: true,
      formatter: formatCurrency,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Client Name",
      dataField: "clientName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Exp Date",
      dataField: "expiredDate",
      formatter: dateFormatter,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Remarks Return",
      dataField: "remark",
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Photo Product",
      dataField: "attachmentId",
      formatter: attachFormatter,
    },
  ];

  const options = {
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList,
  };

  const onSelectRow = {
    mode: "checkbox",
    onSelectAll: (status) => {
      setOnSelectAll(status);
    },
    onSelect: (row, isSelect, rowIndex) => {
      if (isSelect) {
        setSelectedRows([...selectedRows, row]);
      } else {
        const index = selectedRows.indexOf(row);
        if (index > -1) {
          selectedRows.splice(index, 1);
        }
      }
    },
  };

  const id = [
    // "cf85f1fd-3e13-4a38-871f-b97050d7219d",
  ];

  let uniqueArr = [...new Set(id)];

  const res = uniqueArr.map((uniqueArr) => ({ uniqueArr }));

  return (
    <>
      <BootstrapTable
        remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden"
        bootstrap4
        bordered={false}
        keyField="approvalDetailId"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        selectRow={onSelectRow}
        hover
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>

      {/* Footer */}
      <Row className="mt-4">
        <Col sm={1}>
          <Button
            variant="success"
            onClick={() => {
              if (onSelectAll) {
                dispatch(setApproval(data));
                history.push(`/fss-asm-bm/sales-detail`);
              } else if (selectedRows.length > 0) {
                dispatch(setApproval(selectedRows));
                history.push(`/fss-asm-bm/sales-detail`);
              } else {
                showDialog("Please select row first");
              }
            }}
          >
            Next
          </Button>
        </Col>
        <Col sm={1}>
          <Button variant="outline-danger" onClick={() => history.push("/")}>
            Back
          </Button>
        </Col>
      </Row>
    </>
  );
};
